import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-author-card.css.lit';

import '../ghs-heading/ghs-heading';

/**
 * The The Author Card component
 *
 * @element ghs-author-card
 * @slot image - Contains the image
 * @slot cta - Contains the CTA link
 */
@customElement('ghs-author-card')
export class GhsAuthorCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Whether or not the component should have a y-axis border.
   */
  @property({ type: Boolean, attribute: 'y-border', reflect: true })
  yBorder = true;
  /**
   * The heading text.
   * @param heading
   */
  @property({ type: String })
  heading = '';
  /**
   * The title text.
   * @param title
   */
  @property({ type: String })
  title = '';
  /**
   * The topic text.
   * @param topic
   */
  @property({ type: String })
  topic = '';

  @state() hasImageSlot: boolean;
  @state() hasCtaSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasImageSlot = this.querySelector('[slot="image"]') !== null;
    this.hasCtaSlot = this.querySelector('[slot="cta"]') !== null;
  }

  render(): TemplateResult {
    return html`
      <div class="author-card ${this.yBorder && 'y-border'}">
        ${this.heading
          ? html` <ghs-heading
              level="h5"
              level-size="lg"
              class="author-card-heading"
              site=${this.site}
            >
              ${this.heading}
            </ghs-heading>`
          : ''}
        ${this.hasImageSlot
          ? html`
              <div class="author-card-image">
                <slot name="image"></slot>
              </div>
            `
          : nothing}
        ${this.title
          ? html`
              <ghs-heading
                level="h6"
                level-size="2xl"
                level-style="bold"
                class="author-card-title"
                site=${this.site}
              >
                ${this.title}
              </ghs-heading>
            `
          : nothing}
        ${this.topic
          ? html` <p class="author-card-topic">${this.topic}</p> `
          : nothing}
        ${this.hasCtaSlot
          ? html`
              <div class="author-card-cta">
                <slot name="cta"></slot>
              </div>
            `
          : nothing}
      </div>
    `;
  }
}
